// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 900) return "static/chunks/900-f13663734574d670.js";
	if (chunkId === 510) return "static/chunks/510-5f91bdf3db4f31e1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"70842944fd1b37b4","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"3d3de3f3d72d8d9a","367":"4c17d37fc8541b23","639":"a322f5d778fbd249","748":"b347bc8d22a409cf"}[chunkId] + ".js";
};